import { connect } from 'react-redux';
import View from './VerticalNavigationMenuView';
import {
  currentClientIdSelector,
  showReportsSelector,
  isFinancialPlanEnabledSelector,
  showPortfolioReportsSelector,
} from '../../CommonSelectors/CommonAreaSelector';
import {
  navigationItemsSelector,
  hasFinancialPlanSelector,
  isFinancialPlanSelectedSelector,
} from './VerticalNavigationMenuSelector';

const mapStateToProps = (state, ownProps) => ({
  navigationItems: navigationItemsSelector(state, ownProps),
  clientId: currentClientIdSelector(state, ownProps),
  hasFinancialPlan: hasFinancialPlanSelector(state, ownProps),
  isFinancialPlanSelected: isFinancialPlanSelectedSelector(state, ownProps),
  showReports: showReportsSelector(state),
  isFinancialPlanEnabled: isFinancialPlanEnabledSelector(state),
  showPortfolioReports: showPortfolioReportsSelector(state),
});

const mapDispatchToProps = () => ({
  navigateTo: (controller, params) => {
    window.ADV.util.Router.go2(controller, params);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
